<!-- splash -->
<div
  class="absolute top-0 left-0 w-full h-80 -z-10"
  style="background: linear-gradient(135deg, rgb(20 51 93), rgb(11 23 40) 50%)"
></div>

<!-- header -->
<blu-header theme="dark"></blu-header>

<!-- announcements -->
@for (announcement of announcements()(); track $index) {
  <blu-announcement
    class="text-white"
    [announcement]="announcement"
  ></blu-announcement>
}

<!-- content -->
<router-outlet></router-outlet>

<!-- modal -->
<router-outlet name="modal"></router-outlet>
